import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { VistoCorridoService } from '@/core/api/sicom-api/servicos/pessoa-fisica/visto-corrido/visto-corrido.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { VistoCorridoRequest, VistoCorridoResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/visto-corrido/visto-corrido.model';

@Injectable({ providedIn: 'root' })
export class VistoFracionadoServicosService {
    constructor(
        private api: VistoCorridoService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: VistoCorridoRequest, context?: HttpContext): Observable<VistoCorridoResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
